import createIcon from '../../createIcon';

/**
 * @component @name Link
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy45IDEyQzMuOSAxMC4yOSA1LjI5IDguOSA3IDguOUgxMVY3SDdDNC4yNCA3IDIgOS4yNCAyIDEyQzIgMTQuNzYgNC4yNCAxNyA3IDE3SDExVjE1LjFIN0M1LjI5IDE1LjEgMy45IDEzLjcxIDMuOSAxMlpNOCAxM0gxNlYxMUg4VjEzWk0xNyA3SDEzVjguOUgxN0MxOC43MSA4LjkgMjAuMSAxMC4yOSAyMC4xIDEyQzIwLjEgMTMuNzEgMTguNzEgMTUuMSAxNyAxNS4xSDEzVjE3SDE3QzE5Ljc2IDE3IDIyIDE0Ljc2IDIyIDEyQzIyIDkuMjQgMTkuNzYgNyAxNyA3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Link = createIcon('Link', [
  [
    'path',
    {
      d: 'M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z',
      key: '1u1iqj',
    },
  ],
]);

export default Link;
